module.exports = __webpack_public_path__ + "static/media/backArrow.6b0263fe.svg";